import { Entity, Fields, Relations, Allow } from "remult";
import { Chat } from "../chat/entity";
import { Member } from "../member/entity";

@Entity("chat-member", {
    allowApiRead: Allow.authenticated,
    // Rules from .zmodel: users can read if they are a member, create if themselves or related to opportunity.
    // For admin/internal tools, keeping it readable by authenticated users for now, and restricted on crud.
    allowApiCrud: false
})
export class ChatMember {
    @Fields.string({ dbName: "member_id" })
    memberId = "";

    @Fields.string({ dbName: "chat_id" })
    chatId = "";

    @Relations.toOne(() => Chat, "chatId")
    chat?: Chat;

    @Relations.toOne(() => Member, "memberId")
    member?: Member;

    @Fields.date({ dbName: "last_read_at", allowNull: true })
    lastReadAt?: Date;

    @Fields.boolean({ dbName: "has_left_chat" })
    hasLeftChat = false;

    @Fields.createdAt({ dbName: "created_at" })
    createdAt = new Date();

    @Fields.updatedAt({ dbName: "updated_at" })
    updatedAt = new Date();
}
